import React, { useState, useEffect } from 'react';
import Header from '../Header/Header.jsx';
import Footer from '../Footer/Footer.jsx';
import styles from './BookCoversGallery.module.css';

import BookCover1 from '../../images/Shikkari_Shambhu_.jpg';
import BookCover2 from '../../images/Ruskin_Bond__-_Great_Stories_For_Children.jpg';
import BookCover3 from '../../images/The_Cherry_Tree.jpg';
import BookCover4 from '../../images/Vailoppilli__Final.jpg';
import BookCover5 from '../../images/Cover_page-0001.jpg';

const BookCoversGallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [mode, setMode] = useState('graphic');
  const [scrolled, setScrolled] = useState(false);
  const [hoveredId, setHoveredId] = useState(null);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const bookCovers = [
    { id: 1, url: BookCover1, title: 'Chilldrens Book' },
    { id: 2, url: BookCover2, title: 'Chilldrens Book' },
    { id: 3, url: BookCover3, title: 'Chilldrens Book' },
     { id: 4, url: BookCover4, title: 'Chilldrens Book' },
     { id: 5, url: BookCover5, title: 'Chilldrens Book' },
  ];

  return (
    <>
      <Header mode={mode} setMode={setMode} menuOpen={menuOpen} setMenuOpen={setMenuOpen} scrolled={scrolled} />

      <div className={styles.portfolioContainer}>
        {/* Animated Particle Background */}
        <div className={styles.animatedBackground}>
          <div className={styles.particlesWrapper}>
            {[...Array(30)].map((_, i) => (
              <div key={i} className={`${styles.particle} ${styles[`particle${i % 5}`]}`} />
            ))}
          </div>
          <div className={`${styles.gradientOrb} ${styles.orb1}`}></div>
          <div className={`${styles.gradientOrb} ${styles.orb2}`}></div>
          <div className={`${styles.gradientOrb} ${styles.orb3}`}></div>
          <div className={`${styles.gradientOrb} ${styles.orb4}`}></div>
          
          {/* Floating Books Animation */}
          <div className={styles.floatingBooks}>
            <div className={`${styles.floatingBook} ${styles.book1}`}>📚</div>
            <div className={`${styles.floatingBook} ${styles.book2}`}>📖</div>
            <div className={`${styles.floatingBook} ${styles.book3}`}>📕</div>
            <div className={`${styles.floatingBook} ${styles.book4}`}>📘</div>
          </div>
        </div>

        <div className={styles.contentWrapper}>
          <div className={styles.headerSection}>
            <h1 className={styles.galleryTitle}>
              <span className={styles.titleWord}>Book</span>
              <span className={styles.titleWord}>Cover</span>
              <span className={styles.titleWord}>Designs</span>
            </h1>
            <div className={styles.titleDecoration} />
          </div>

          <div className={styles.descriptionSection}>
            <div className={styles.descriptionCard}>
              <div className={styles.quoteIcon}>"</div>
              <p className={styles.descriptionText}>
                I crafted captivating images for a renowned book publishing company's trail, enticing readers with visual allure. Each image meticulously designed to evoke curiosity and anticipation, enhancing the allure of the forthcoming literary masterpiece.
              </p>
            </div>
          </div>

          <div className={styles.galleryGrid}>
            {bookCovers.map((book, index) => (
              <div
                key={book.id}
                className={`${styles.galleryItem} ${hoveredId === book.id ? styles.hovered : ''}`}
                onClick={() => setSelectedImage(book)}
                onMouseEnter={() => setHoveredId(book.id)}
                onMouseLeave={() => setHoveredId(null)}
                style={{ animationDelay: `${index * 0.15}s` }}
              >
                <div className={styles.bookWrapper}>
                 
                  <div className={styles.imageContainer}>
                    <img src={book.url} alt={book.title} className={styles.bookCoverImage} />
                    
                  </div>
                  <div className={styles.glowEffect}></div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <Footer mode={mode} background="illustrations" />

        {selectedImage && (
          <div className={styles.modalOverlay} onClick={() => setSelectedImage(null)}>
            <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
              <button className={styles.closeBtn} onClick={() => setSelectedImage(null)}>
                <span className={styles.closeLine1}></span>
                <span className={styles.closeLine2}></span>
              </button>
              <div className={styles.modalImageWrapper}>
                <img
                  src={selectedImage.url}
                  alt={selectedImage.title}
                  className={styles.modalImage}
                />
                <div className={styles.modalGlow}></div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default BookCoversGallery;